import { Button, styled, Tab, Box } from "@mui/material";
import { brighthiveTheme } from "../../theme/theme";

export const ModalHolder = styled("div")`
  padding: 30px;
`;
export const ModalTitle = styled("h3")`
  font-size: 32px;
  line-height: 1.2;
  margin: 0 0 15px;
`;
export const ModalDes = styled("p")`
  margin: 0 0 30px;
`;
export const BtnHolder = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  button {
    min-width: 100px;
  }
`;
